/* eslint-disable no-console */
import { get, isEmpty, each } from 'lodash';
import AnalyticsService from './service';
import AnalyticsEvent from '../events/event';
import { debugEnabled } from '../index';

export default class GoogleAnalytics extends AnalyticsService {
  get name() {
    return 'Google Analytics';
  }

  get enabled() {
    return window && window.ga && typeof window.ga === 'function';
  }

  _track(event) {
    if (!this.enabled) {
      return;
    }

    if (!event instanceof AnalyticsEvent) {
      console.error('ga _track method can only receive events that are instances of AnalyticsEvent', event);
      return;
    }

    const eventLabel = get(event, 'gaEventLabel');
    const ecommerceProperties = get(event, 'gaEcommerceProperties');

    if (debugEnabled) {
      console.info(`ga tracking event: ${event.category}: ${event.name}`, { eventLabel });
    }

    window.ga('send', 'event', event.category, event.name, eventLabel);
    if (!isEmpty(ecommerceProperties)) {
      this.trackEcommerceProperties(ecommerceProperties);
    }
  }

  trackEcommerceProperties(ecommerceProperties) {
    if (!this.enabled) {
      return;
    }

    window.ga('require', 'ecommerce');

    window.ga('ecommerce:addTransaction', get(ecommerceProperties, 'addTransaction'));
    if (debugEnabled) {
      console.info('ga ecommerce:addTransaction: ', get(ecommerceProperties, 'addTransaction'));
    }

    each(get(ecommerceProperties, 'items'), (item) => {
      window.ga('ecommerce:addItem', item);
      if (debugEnabled) {
        console.info('ga ecommerce:addItem: ', item);
      }
    });

    window.ga('ecommerce:send');
  }
}
